import { render, staticRenderFns } from "./TerminalSetup.vue?vue&type=template&id=bc842ac8&scoped=true"
import script from "./TerminalSetup.vue?vue&type=script&lang=js"
export * from "./TerminalSetup.vue?vue&type=script&lang=js"
import style0 from "./TerminalSetup.vue?vue&type=style&index=0&id=bc842ac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc842ac8",
  null
  
)

export default component.exports